import React from "react";
import CommonTable from "components/CommonTable";
import { l } from "helpers/log";
import { getErrorMessage } from 'helpers/strings';
import styled from "styled-components";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Spinner } from "react-bootstrap";
import { TbEditCircle } from "react-icons/tb";
import { TiDocumentDelete } from "react-icons/ti";
import { getProducts, deleteProductItem } from "network/apis/ProductApi";
import useModal from "hooks/useModal";
import DeleteInputPrompt from "components/DeleteInputPrompt";
import { getPersianFormattedDate } from "helpers/dates";
import HoverText from 'components/HoverText';
import { useCompanySelector, useCompanyDispatch } from 'company-app/redux/company.store';
import { buildFiltersQuery, goToPage } from 'company-app/redux/filter.slice';

const cols = [
  "حذف",
  "ویرایش",
  "توضیحات",
  "تاریخ ثبت",
  "واحد",
  "مقدار",
  "نوع ترکیب",
  "ردیف",
];

const Holder = styled.div`
  width: 100%;

  div.loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
    min-height: 30rem;
  }
`;

const ProductTab = ({ productsData, isLoading, refetch, onEditTap }) => {
  const queryClient = useQueryClient();

  const filterState = useCompanySelector((store) => store.filter);
  const dispatch = useCompanyDispatch();

  const {
    isOpen: isDeleteModalOpen,
    handleOpenModal: handleOpenDeleteModal,
    handleCloseModal: handleCloseDeleteModel,
    data: deleteModalData,
  } = useModal();

  const deleteProductItemMutation = useMutation(deleteProductItem, {
    onSuccess: (res) => {
      if (res && res.status === 204) {
        toast(`با موفقیت حذف گردید`, {
          type: "success",
          position: "bottom-right",
        });

        refetch();
        queryClient.invalidateQueries(['company-get-product-statistics']);
      }
    },
    onError: (err) => {
      toast(getErrorMessage(err), {
        type: "error",
        position: "bottom-right",
      });
    },
  });

  const getListItems = () => productsData?.data?.items ?? [];

  return (
    <Holder>
      {isLoading ? (
        <div className="loading">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <CommonTable
          cols={cols}
          pageCount={parseInt(productsData?.data?.num_pages ?? 1)}
          pageOffset={filterState.pageOffset - 1}
          fetchPageAt={(pageOffset) => {
            dispatch(goToPage(pageOffset));
            dispatch(buildFiltersQuery());
          }}
        >
          {getListItems().reduce((allItems, item) => {
            let indexCounter = allItems.length;
            item.items.forEach((productItem) => {
              indexCounter += 1;

              allItems.push((
                <tr key={`${item?.conc_id}-${productItem.item_id}`}>
                  <td>
                    <TiDocumentDelete
                      onClick={() => {
                        handleOpenDeleteModal(productItem);
                      }}
                    />
                  </td>
                  <td>
                    <TbEditCircle onClick={() => {
                      onEditTap?.(item);
                    }} />
                  </td>
                  <td>
                    <HoverText>{item?.description ?? '-'}</HoverText>
                  </td>
                  <td>{getPersianFormattedDate(item?.created_at)}</td>
                  <td>{productItem?.unit?.name}</td>
                  <td>{`${productItem?.amount ?? 0}`.persianCurrency()}</td>
                  <td>{productItem?.food_item?.name}</td>
                  <td>{indexCounter}</td>
                </tr>
              ));
            });

            return allItems;
          }, [])}
        </CommonTable>
      )}
      {isDeleteModalOpen && (
        <DeleteInputPrompt
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModel}
          onActionTap={(warehouseSelected) => {
            handleCloseDeleteModel();
            deleteProductItemMutation.mutate({ id: deleteModalData?.item_id, warehouseSelected: false });
          }}
        />
      )}
    </Holder>
  );
};

export default ProductTab;
